import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const reviews = [{
  text: 'My 7-year-old built his first robot in 20 minutes and has not asked for the tablet since. The best money I have ever spent as a parent.',
  name: 'Jessica M.',
  meta: 'Mom of 2 · Texas, USA',
  letter: 'J',
  color: 'bg-brand',
  textTone: 'text-white',
  tone: 'bg-brand-light'
}, {
  text: 'I was skeptical at first — “another digital product” — but the guides are so clear that even I could follow them. My daughter is obsessed.',
  name: 'Sarah K.',
  meta: 'Mom of 3 · London, UK',
  letter: 'S',
  color: 'bg-mint',
  textTone: 'text-ink',
  tone: 'bg-mint-light'
}, {
  text: 'We do a project every Saturday morning now. My son calls it “Robot Day.” He has learned more about engineering in two months than in a whole school year.',
  name: 'Michael R.',
  meta: 'Dad of 1 · Sydney, AU',
  letter: 'M',
  color: 'bg-sky',
  textTone: 'text-ink',
  tone: 'bg-sky-light'
}, {
  text: 'The bonus progress tracker was such a brilliant idea. My kids compete to see who can finish more projects. The fights over screens have almost disappeared.',
  name: 'Rachel T.',
  meta: 'Mom of 4 · Toronto, CA',
  letter: 'R',
  color: 'bg-sunshine',
  textTone: 'text-ink',
  tone: 'bg-sunshine-light'
}, {
  text: 'Downloaded it Friday night, printed the quick-start guide, and by bedtime we had a working robot. My 5-year-old was so proud. Worth every penny.',
  name: 'Laura B.',
  meta: 'Mom of 2 · Madrid, ES',
  letter: 'L',
  color: 'bg-coral',
  textTone: 'text-ink',
  tone: 'bg-coral-light'
}];
function Stars() {
  return <div className="flex text-amber-400" aria-hidden="true" data-id="element-179" data-mp="1ivk4zcib5a99">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" data-id="element-180" data-mp="1nn255ycib6t6" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-181" data-mp="1xh7pwzwc4it6">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-182" data-mp="1sie84va0m5n7">
        <SectionHeading eyebrow="What parents are saying" title={<>Real families. Real results.</>} subtitle="More than 2,000 families have already used MakerLab to get their kids off screens and building something real. Here is what they say." data-id="element-183" data-mp="1sgtdl5npampc" />

        <div className="mt-8 flex items-center justify-center gap-3" data-id="element-184" data-mp="1ekfxo0ytetcz">
          <Stars data-id="element-185" data-mp="19rdd2ic0mu8x" />
          <p className="text-sm font-semibold text-ink" data-id="element-186" data-mp="19qvaz52o9lt3">
            2,000+ families — 4.9 out of 5 average
          </p>
        </div>

        <div className="mt-12 columns-1 gap-6 sm:columns-2 lg:columns-3 [&>*]:mb-6" data-id="element-187" data-mp="10rqc1xn77qge">
          {reviews.map((r, i) => <motion.figure key={r.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i % 3 * 0.08
        }} className={`break-inside-avoid rounded-3xl border border-ink/10 p-6 ${r.tone}`} data-id="element-188" data-mp="vt6mzodb5yjt" data-mpi={i}>
              <Stars data-id="element-189" data-mp="3gecbbt0g8a58" />
              <blockquote className="mt-3 text-sm leading-relaxed text-ink/80" data-id="element-190" data-mp="2jqxz681tuzd0">
                “{r.text}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3" data-id="element-191" data-mp="2oqamsv0iwagn">
                <span className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold ${r.color} ${r.textTone}`} data-id="element-192" data-mp="2sqkq1zwxkmrt">
                  {r.letter}
                </span>
                <span data-id="element-193" data-mp="20z566dmrde5a">
                  <span className="block text-sm font-bold text-ink" data-id="element-194" data-mp="20zofj5yceu7p">
                    {r.name}
                  </span>
                  <span className="block text-xs text-ink/50" data-id="element-195" data-mp="1lwwo9xex6ujk">{r.meta}</span>
                </span>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}